import React, { Component } from "react";

import axios from "axios";
import Conf from "./Conf";
import Navbar from "./components/Navbar";
import BillPreview from "./components/BillPreview";
import { goLogin, getPermission } from "./js/main";

const current_path = Conf.frontendURL + "bill/";
export default class Bill extends Component {
  state = {};
  componentDidMount() {
    this.getAuth();
  }
  async getAuth() {
    var bill_id = this.props.match.params.no;
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if (cookie && cookie.token) {
      var auth = await getPermission(cookie.token);
      if (auth === false) goLogin(current_path + bill_id);
      else {
        console.log(auth);
        var otp = await this.getOTP();
        console.log(otp);
        this.setState({ profile: auth.profile, cookie, bill_id, otp }, () =>
          this.getOTP()
        );
      }
    } else goLogin(current_path + bill_id);
  }
  getOTP() {
    return new Promise((resolve) => {
      var bill_id = this.props.match.params.no;
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      axios
        .post(
          Conf.digitalpayBackend + "otp",
          { type: "bill_preview", payload: { bill_id: bill_id } },
          {
            headers: { Authorization: cookie.token },
          }
        )
        .then((res) => {
          resolve(res.data);
        });
    });
  }
  render() {
    const { profile, otp } = this.state;
    return (
      <div>
        {profile && (
          <div>
            <Navbar />

            <main className="content">
              {otp && <BillPreview otp={otp} />}
              {/* <object
                aria-label="pdf"
                data={
                  Conf.digitalpayBackend +
                  "bill/file/" +
                  this.props.match.params.no
                }
                type="application/pdf"
                style={{ height: "90vh", width: "100%", objectFit: "cover" }}
              ></object> */}
            </main>
          </div>
        )}
      </div>
    );
  }
}
